/**
 * Modern section header — brand-gradient icon chip + high-contrast title.
 * Each section takes a segment of the OmniConnX logo ramp
 * (orange → pink → violet → blue).
 */

// Brand gradient segments (tailwind class pairs) — pick per section for variety.
export const BRAND_SEGMENTS = {
  orangePink: 'from-orange-400 to-pink-500',
  pinkFuchsia: 'from-pink-500 to-fuchsia-600',
  fuchsiaViolet: 'from-fuchsia-500 to-violet-600',
  violetBlue: 'from-violet-500 to-blue-600',
};

// Full logo ramp as CSS — for hero banners.
export const BRAND_HERO_GRADIENT =
  'linear-gradient(105deg, #ff7a1a 0%, #f43f7b 32%, #a855f7 66%, #3b82f6 100%)';

const SectionTitle = ({ icon: Icon, children, right, className = 'mb-4', gradient = BRAND_SEGMENTS.pinkFuchsia }) => (
  <div className={`flex items-center justify-between ${className}`}>
    <div className="flex items-center gap-2">
      {Icon && (
        <span className={`w-6 h-6 rounded-lg bg-gradient-to-br ${gradient} flex items-center justify-center shadow-sm flex-shrink-0`}>
          <Icon className="w-3.5 h-3.5 text-white" />
        </span>
      )}
      <h3 className="text-sm font-bold text-gray-800 dark:text-white tracking-tight">{children}</h3>
    </div>
    {right}
  </div>
);

export default SectionTitle;
